import React, { memo } from 'react';
import styles from '../../../../../pages/Conversations/Conversations.module.scss';

const NoMessages = () => (
  <div className={styles['paragraph-block']}>
    <p className={styles['messages-paragraph']}>Select a chat to start messaging</p>
  </div>
);

export default memo(NoMessages);
